import { Row } from 'antd';
import React from 'react';

interface Props {
  type: string;
  newTitle: string;
  editTitle?: string;
  subTitle?: JSX.Element | string;
}

class FormHeader extends React.Component<Props> {
  render = () => (
    <Row>
      <div>
        <img
          alt='Banner'
          style={{ width: '100%' }}
          src={require('../../images/logistics-banner.jpg')}
        />
        <p
          key={1}
          style={{
            fontSize: '30px',
            color: 'white',
            fontWeight: 500,
            position: 'absolute',
            top: 90,
            textAlign: 'center',
            width: '100%'
          }}
        >
          {this.props.type === 'edit' ? this.props.editTitle : this.props.newTitle}
          {this.props.subTitle}
        </p>
      </div>
    </Row>
  );
}

export default FormHeader;
